export type AiMarkerKind = "generated" | "modified" | "unspecified";

/**
 * The AI markers, longest first.
 *
 * The order is load-bearing and must not be alphabetized or "tidied". `::ai` is a
 * proper prefix of the other two, so a shorter-first scan classifies every
 * `::ai-generated` as `unspecified` — and does it silently, selecting the wrong
 * disclaimer copy rather than raising anything.
 */
export const AI_MARKERS = [
  { marker: "::ai-generated", kind: "generated" },
  { marker: "::ai-modified", kind: "modified" },
  { marker: "::ai", kind: "unspecified" },
] as const satisfies readonly { marker: string; kind: AiMarkerKind }[];
